
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
import { getDayJsLocale } from "@/helpers/utils";
import { UserInfo } from "@/services/apiService/api.types";
import { defaultUserInfo } from "@/helpers/constants";
import apiStorageInterface from "@/services/apiStorageInterface";
require("dayjs/locale/sr");
require("dayjs/locale/en");

@Component({})
export default class DateTimeSection extends Vue {
  currTime = "";

  dayJsLocale = "";

  userInfo: UserInfo = defaultUserInfo;

  get currDate(): string {
    this.dayJsLocale = getDayJsLocale();
    return dayjs().locale(this.dayJsLocale).format("dddd, MMMM D, YYYY");
  }

  async mounted(): Promise<void> {
    this.currTime = dayjs().locale(this.dayJsLocale).format("HH:mm");
    setInterval(() => {
      this.currTime = dayjs().locale(this.dayJsLocale).format("HH:mm");
    }, 1000);

    this.userInfo = await apiStorageInterface.fetchUserInfo();
  }

  get userInitials(): string {
    return this.userInfo.profile.first_name
      .charAt(0)
      .concat(this.userInfo.profile.last_name.charAt(0))
      .toUpperCase();
  }
}
